import UserBottom from "./Bottom/User";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { Link } from "react-router-dom";
import presences from "@/presences";
import BotTag from "../Tags/Bot";
import Icon from "@/icons";
import ErrorBoundary from "@/ErrorBoundary";
import { useQueryClient } from "@tanstack/react-query";
import { ManageMember } from "../ContextMenu/Member";
export default function Chats({ socket, chats, isOpen, setHidden, streamerMode }: { socket: any, chats: any, isOpen: any, setHidden: any, streamerMode: any }) {

    const isActive = (path: string) => {
        return window.location.pathname === path ? "bg-brand-darkest" : "";
    };
    const queryClient = useQueryClient();
    const unreadedMessages = queryClient.getQueryState(["unreadedMessages"]) as any;
    const user = queryClient.getQueryState(["user"]) as any;
    return (
        <div className={`sm:p-4 sm:h-full w-auto flex flex-col sm:gap-8 ${isOpen == 2 ? 'z-10 sm:pb-0 flex w-72' : 'hidden sm:flex'} `}>
            <div className={`flex-col shadow-2xl bg-brand-dark h-full sm:relative sm:rounded-lg min-w-[19.5rem] sm:min-w-72 transition-all duration-300 ease-linear`}>
                <div className="flex flex-col flex-grow overflow-y-auto" style={{ scrollbarWidth: "none" }}>
                    <div className="flex flex-col max-h-80 border-gray-600">
                        <div className="flex px-2 py-8 h-12 mt-2">
                            <h1 className="text-gray-300 font-semibold px-2 text-sm">Direct Messages</h1>
                        </div>
                        <div className="flex flex-col gap-2 px-2 py-2 flex-grow">
                            {chats?.sort((a: any, b: any) => {
                                if (a.lastMessage?.createdAt > b.lastMessage?.createdAt) return -1;
                                if (a.lastMessage?.createdAt < b.lastMessage?.createdAt) return 1;
                                return 0;
                            })
                                ?.map((chat: any) => (
                                    <Link to={`/chat/${chat.id}`} key={chat.id}
                                        className={`flex hover:bg-brand-darkest group gap-2 px-2 py-2 rounded-lg items-center cursor-pointer ${isActive(`/chat/${chat.id}`)}`}
                                    >
                                        <ErrorBoundary>
                                            <ManageMember member={chat.users[0]}>
                                            <div className="flex  justify-between w-full">
                                                <div className="flex items-center gap-2">
                                                    <div className="relative">
                                                        <Avatar className="bg-gray-600 w-10 h-10">
                                                            <AvatarImage src={chat.users[0].profilePicture?.replace("webp", "png")} className="rounded-full group-hover:hidden" />
                                                            <AvatarImage src={chat.users[0].profilePicture} className="rounded-full group-hover:block" />
                                                            <AvatarFallback>{chat.users[0].username[0].toUpperCase()}</AvatarFallback>
                                                        </Avatar>
                                                        <div className="absolute bottom-0 right-0 w-3 h-3 rounded-full" style={{ backgroundColor: presences.get(chat.users[0].presence) }} />
                                                    </div>
                                                    <div className="flex flex-col">
                                                        <p className="text-gray-300 font-semibold text-sm">{chat.users[0].username}</p>
                                                        <BotTag user={chat.users[0]} />
                                                        {!streamerMode?.enabled || !streamerMode?.details?.hideLastMessagesOnDMs ? (
                                                            <p className="text-gray-500 font-semibold text-xs">
                                                                {chat.lastMessage?.content?.slice(0, 16)}{chat.lastMessage?.content?.length > 16 ? "..." : ""}
                                                            </p>
                                                        ) : null}

                                                        {chat.lastMessage?.id &&!chat.lastMessage?.isDeleted && !chat.lastMessage?.content && (
                                                            <div className="text-gray-500 font-semibold text-xs flex items-center gap-1">
                                                                <Icon name="picture" size="16" />
                                                                <p>Image</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="flex items-center">
                                                    {Boolean(unreadedMessages?.dmInfo?.[chat.id]?.unread) && unreadedMessages?.dmInfo?.[chat.id]?.unread > 0 && (
                                                        <div className="flex items-center justify-center w-4 h-4 bg-red-500 rounded-full text-white font-semibold text-xs">
                                                            {unreadedMessages?.dmInfo?.[chat.id].unread > 99 ? "99+" : unreadedMessages?.dmInfo?.[chat.id]?.unread}
                                                        </div>
                                                    )}
                                                    <div className="text-gray-500 font-semibold text-sm hidden group-hover:flex mr-2 hover:text-gray-200 duration-200 ease-linear" onClick={(e) => {
                                                        e.stopPropagation();
                                                        setHidden(chat.id)
                                                    }}>
                                                        <Icon name="delete" size="16" />
                                                    </div>
                                                </div>
                                            </div>
                                            </ManageMember>
                                        </ErrorBoundary>
                                    </Link>
                                ))
                            }

                        </div>

                    </div>
                </div>
            </div>
            <UserBottom user={user.data} socket={socket} />
        </div>
    );
}
